<div class="navBar">
  <app-navbar [currentRoute]="'table'" [crntYear]="crntYear" [data]="data" [main]="true"></app-navbar>
</div>
<div class="table">
  <div class="tableTabs" *ngIf="isLoaded">
    <div class="options">
      <div class="selectContainer">
        <select class="year" [(ngModel)]="crntYear" (change)="switchTable()">
          <option readonly disabled>Select a Year</option>
          <option *ngFor="let item of data;let i = index;" [value]="i">{{ item.Year }}</option>
        </select>
      </div>
      <div class="statusContainer">
        <select class="year" (change)="switchStatus($event)">
          <option readonly disabled>Select a Status</option>
          <option [value]="'asc'" selected>Inspected</option>
          <option [value]="'desc'">Uninspected</option>
          <option [value]="''">All</option>
        </select>
      </div>
      <div class="filterProcessedStatus">
        <mat-form-field appearance="fill" >
          <mat-label>Processed Status</mat-label>
          <mat-select (selectionChange)="applyProcessedStatusFilter($event.value)" (focus)="setupFilter('processed')">
            <mat-option *ngFor="let prstatus of processedStatus" [value]="prstatus">
              {{prstatus}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="filterContainer">
        <mat-form-field>
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #filter [(ngModel)]="selectedStatus">
        </mat-form-field>
      </div>
      <div class="downloadContainer" *ngIf="isIHS" style="width: 152px;">
        <button class="download summaries" style="margin-left: 0;" (click)="downloadExcelReport()"><i class="fas fa-file"></i> Download Data</button>
        </div>
      <div class="downloadContainer">
      <button class="download summaries" (click)="downloadCSV('Summaries')"><i class="fas fa-file"></i> Download Excel Summaries</button>
      </div>
      <div class="downloadContainer" *ngIf="role == 'aero-processing'">
        <button class="download summaries" style="position:relative;display:flex;" (click)="openProcessedDialog()"><mat-progress-spinner *ngIf="isProcessing" mode="indeterminate" [diameter]="15"></mat-progress-spinner><div>Update Processed Status</div></button>
      </div>
    </div>
    <div class="mat-elevation-z8">
      <table class="tableContainer" matSort (matSortChange)="sortData($event)" matSortActive="Status" mat-table [dataSource]="dataSource" >
        
        <!-- Position Column -->
        <ng-container matColumnDef="No">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
          <td mat-cell  *matCellDef="let i = index"> {{i+1}} </td>
          <td mat-footer-cell *matFooterCellDef>  </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="Tower">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Name </th>
          <td mat-cell  *matCellDef="let element"> {{element.TowerName}} </td>
          <td mat-footer-cell *matFooterCellDef>  </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="SiteID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> SiteID </th>
          <td mat-cell   *matCellDef="let element" >{{element.SiteID}} </td>
          <td mat-footer-cell *matFooterCellDef> Total </td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell   *matCellDef="let element"  > {{element.Status}} <i class="edit"  *ngIf="role == 'aero-processing'" (click)="clickEvent(element.Status,$event,true,element.SiteID,element.Status,'Status')"> <mat-icon class="editIcon">edit</mat-icon></i></td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="Completed">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Completed </th>
          <td mat-cell   *matCellDef="let element"  > {{element.Completed}} <i class="edit"  *ngIf="role == 'aero-processing'" (click)="clickEvent(element.Completed,$event,true,element.SiteID,element.Completed,'Completed')"> <mat-icon class="editIcon">edit</mat-icon></i></td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="Latitude">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Latitude </th>
          <td mat-cell   *matCellDef="let element"  > {{element.Latitude}} </td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="Longitude">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Longitude </th>
          <td mat-cell   *matCellDef="let element"  >{{element.Longitude}}  </td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="Processed">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Processed </th>
           <td mat-cell  *matCellDef="let element" title="T - TowerView,D - DigitalTwin,O - OrthoMap,N/A - Not updated,'-' - No Data"> {{element.processed}} </td>
           <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>


        <!-- <ng-container matColumnDef="StructureType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Structure Type </th>
          <td mat-cell   *matCellDef="let element"  > {{element.StructureType}} <i class="edit"  *ngIf="role == 'super-admin' || role == 'aero-processing' || role == 'telstra-admin'" (click)="clickEvent(element.StructureType,$event,true,element.SiteID,'StructureType')"> <mat-icon class="editIcon">edit</mat-icon></i></td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="CanradVariation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Canrad Variation </th>
          <td mat-cell   *matCellDef="let element"  > {{element.CanradVariation}} <i class="edit"  *ngIf="role == 'super-admin' || role == 'aero-processing' || role == 'telstra-admin'" (click)="clickEvent(element.CanradVariation,$event,true,element.SiteID,'CanradVariation')"> <mat-icon class="editIcon">edit</mat-icon></i></td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container> -->


        <ng-container matColumnDef="Emergency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#cb405b"> Emergency </th>
           <td mat-cell class="numberCells"  *matCellDef="let element" ><div class='critical'><span >{{ getIssueCount(element.TowerName,"Emergency") }} </span> </div></td>
           <td mat-footer-cell class="numberCells" *matFooterCellDef> <div class='critical'><span >{{ getTotal("Emergency") }}</span></div> </td>
        </ng-container>

        <ng-container matColumnDef="Urgent">
          
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#ff7744">Urgent </th>
          <td mat-cell class="numberCells" *matCellDef="let element"> <div class='major'><span >{{ getIssueCount(element.TowerName,"Urgent") }}</span> </div></td>
          <td mat-footer-cell class="numberCells" *matFooterCellDef> <div class='major'><span >{{ getTotal("Urgent") }}</span></div> </td>
        </ng-container>

        <ng-container matColumnDef="Planned">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#ffcc66"> Planned </th>
          <td mat-cell class="numberCells"  *matCellDef="let element"  ><div class="minor"><span >{{ getIssueCount(element.TowerName,"Planned") }}</span></div>  </td>
          <td mat-footer-cell class="numberCells" *matFooterCellDef> <div class="minor"><span >{{ getTotal("Planned") }}</span></div> </td>
        </ng-container>

        <ng-container matColumnDef="Monitor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#30ad63"> Normal </th>
          <td mat-cell class="numberCells"  *matCellDef="let element"><div class="without"><span >{{ getIssueCount(element.TowerName,"Monitor") }}</span></div> </td>
          <td mat-footer-cell class="numberCells" *matFooterCellDef><div class="without"> <span >{{ getTotal("Monitor") }}</span> </div></td>
        </ng-container>

        <!-- ////? -->

        <ng-container matColumnDef="Critical" *ngIf="isAIS">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#cb405b; border-left: 1px solid #cbcbcb"> Critical </th>
           <td mat-cell class="numberCells"  *matCellDef="let element" class="borderClass" ><div class='critical'><span >{{ getIssueCount(element.TowerName,"Critical") }} </span> </div></td>
           <td mat-footer-cell class="numberCells" *matFooterCellDef class="borderClass"> <div class='critical'><span >{{ getTotal("Critical") }}</span></div> </td>
        </ng-container>

        <ng-container matColumnDef="Major" *ngIf="isAIS">
          <p *ngIf="isAIS">Rigger Audit</p>
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#ff7744"> Major </th>
          <td mat-cell class="numberCells" *matCellDef="let element"> <div class='major'><span >{{ getIssueCount(element.TowerName,"Major") }}</span> </div></td>
          <td mat-footer-cell class="numberCells" *matFooterCellDef> <div class='major'><span >{{ getTotal("Major") }}</span></div> </td>
        </ng-container>

        <ng-container matColumnDef="PassStar" *ngIf="isAIS">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#ffcc66"> Pass* </th>
          <td mat-cell class="numberCells"  *matCellDef="let element"  ><div class="minor"><span >{{ getIssueCount(element.TowerName,"PassStar") }}</span></div>  </td>
          <td mat-footer-cell class="numberCells" *matFooterCellDef> <div class="minor"><span >{{ getTotal("PassStar") }}</span></div> </td>
        </ng-container>

        <ng-container matColumnDef="Pass" *ngIf="isAIS">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="numberCells" style="color:#30ad63"> Pass </th>
          <td mat-cell class="numberCells"  *matCellDef="let element"><div class="without"><span >{{ getIssueCount(element.TowerName,"Pass") }}</span></div> </td>
          <td mat-footer-cell class="numberCells" *matFooterCellDef><div class="without"> <span >{{ getTotal("Pass") }}</span> </div></td>
        </ng-container>

        <!-- ///// -->

    
        
        <!-- Header row Blank -->
        <ng-container matColumnDef="header-row-first-group">
          <th mat-header-cell *matHeaderCellDef 
              [style.text-align]="center"
              [attr.colspan]="8"> 
             
          </th>
        </ng-container>
        <!-- Header row first group - UAV -->
        <ng-container matColumnDef="header-row-second-group">
          <th mat-header-cell *matHeaderCellDef 
              [style.text-align]="center"
              [attr.colspan]="4"> 
            UAV Audit
          </th>
        </ng-container>
        
        <!-- Header row second group - Rigger-->
        <ng-container matColumnDef="header-row-third-group">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="4" style="border-left: 1px solid #cbcbcb">Rigger Audit</th>
        </ng-container>


        <div *ngIf="isAIS">
          <tr mat-header-row  *matHeaderRowDef="['header-row-first-group', 'header-row-second-group', 'header-row-third-group']"></tr>
        </div>
        <tr mat-header-row class="rowBack" *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="clickEvent(row.TowerName,$event,false,row.SiteID,row.Status,'')"></tr>
        <tr mat-footer-row class="rowBack" *matFooterRowDef="displayedColumns; "></tr>

      </table>
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10]"></mat-paginator>

      <div class="showStatus">
        <div>Inspected : {{data[crntYear].Towers.filter(inspectedList).length}} Building</div>
        <div>Uninspected : {{data[crntYear].Towers.filter(unInspectedList).length}} Building</div>
       </div>
    </div>

  </div>
  </div>
